import { render, staticRenderFns } from "./BodegaChoferes.vue?vue&type=template&id=d2e08b64&scoped=true"
import script from "./BodegaChoferes.vue?vue&type=script&lang=js"
export * from "./BodegaChoferes.vue?vue&type=script&lang=js"
import style0 from "./BodegaChoferes.vue?vue&type=style&index=0&id=d2e08b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e08b64",
  null
  
)

export default component.exports